module.exports = __webpack_public_path__ + "static/media/YF94_4.ee68cc7e.jpg";